<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>保洁收入</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">

                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" maxlength="11" style="width:150px" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>



                <el-form-item label="时间范围">
                    <el-date-picker v-model="selectTime" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
          
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>

            </el-form>
             <p style="margin:20px;">{{selectTime==null?'':selectTime[0]}} 至 {{selectTime==null?'':selectTime[1]}}累计保洁出单收益 {{sumHHrSalary}} 元</p>
            <!-- 列表数据 -->
            <!-- 服务者姓名，服务者编号，serviceTime服务日期，amount金额，bookTradeNo服务工单号，serviceItem服务项，type收入类型 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="workerName" label="服务者名称"></el-table-column>
                <el-table-column prop="workerNo" label="服务者编号"></el-table-column>
                <el-table-column prop="bookTradeNo" label="服务工单号"></el-table-column>
                <el-table-column prop="serviceItem" label="服务项" width="200"></el-table-column>

    
                <el-table-column prop="amount" label="金额"></el-table-column>
                <el-table-column prop="type" label="收入类型"></el-table-column>
                           <el-table-column prop="serviceTime" :formatter="dateFormatA" label="服务日期">

                </el-table-column>
                
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

    </div>
</template>
<script>
import url from "@/script/baseUrl.js";
import Pagination from "@/components/common/Pagination";
import commutilData from "@/components/common/commutil.data";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import moment from "moment";

let vm;
export default {
    components: {
        Pagination,
      
    },
    filters: {
       
    },
    data() {
        return {
            
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {

               sourceRelationId:globalData.franchisee.id,// globalData.company.id,
                workerName:'',
              
            },
            selectTime: [],
            listData:[],
            sumHHrSalary:''
            
        };
    },

    mounted() {
       let currentTime = new Date().getTime();
    let currentDate = this.formateDay(
      new Date(currentTime - 3600 * 1000 * 24 * 0)
    );

    let startDate = this.formateDay(
      new Date(currentTime - 3600 * 1000 * 24 * 30)
    );
    this.selectTime = [startDate, currentDate];
        this.querySearch();
    },
    methods: {
        //查询
        querySearch() {
            if(this.selectTime==null){
                this.$message.warning('请选择时间');
                return false;
            }
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            if (this.selectTime.length > 0) {
                this.listQuery.startTime = this.selectTime[0] + " 00:00:00";
                this.listQuery.endTime =this.selectTime[1] + " 23:59:59";
            }
            workercrmapi.$axiosHhrSalaryList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.pageList.list;
                    this.total = res.data.data.pageList.total;
                    this.sumHHrSalary= res.data.data.sumHHrSalary;          
                }
            });
        },
      
        
       
       
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>

